import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import 'event-source-polyfill';
import './shared/utils/polyfill'; // Object polyfill for IE10

import React from 'react';
import ReactDOM from 'react-dom';
import ReduxToastr from 'react-redux-toastr';
import { BreadcrumbsProvider } from 'react-breadcrumbs-dynamic';
//import registerServiceWorker from './registerServiceWorker';
// Routes
import Routes from './routes';
// Redux
import { Provider } from 'react-redux';
import Store from './store';
// CSS
import './assets/css/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import 'react-datetime/css/react-datetime.css';

ReactDOM.render(
    <Provider store={Store.store}>
        <BreadcrumbsProvider>
            <div>
                {Routes}
                <ReduxToastr
                    timeOut={3000}
                    newestOnTop
                    preventDuplicates
                    className="fts-toastr"
                    position="top-right"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                />
            </div>
        </BreadcrumbsProvider>
    </Provider>,
    document.getElementById('root')
);
// Register a service worker to enable progressive web app functionality
// Disabled for now...
//registerServiceWorker();
